import { GridButtons } from "@/controls/buttons/GridButtons";
import { Donut } from "@/pages/catalogs/models/Donut";
import { donutStatusCodes } from "@/shared/selectors/DonutStatusSelector";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { DonutStatusTag } from "../components/DonutStatusTag";

type Props = {
	setSelectedRowData: (donut: Donut) => void;
	setShowModal: (modal: "create" | "update" | "delete" | "") => void;
	showContextMenu: Function;
};
export const useTableData = ({
	setSelectedRowData,
	setShowModal,
	showContextMenu,
}: Props) => {
	const columnDefs: ColDef[] = [
		// Hide
		{
			field: "LocationName",
			headerName: "Location",
			hide: true,
		},
		// Visible
		{
			field: "PartName",
			headerName: "Name",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "SectionFamilyName",
			headerName: "Section Family",
			minWidth: 20,
			flex: 1,
		},
		{
			field: "Width",
			headerName: "Width",
			maxWidth: 80,
			flex: 1,
		},
		{
			field: "Diameter",
			headerName: "Diameter",
			maxWidth: 80,
			flex: 1,
		},
		{
			field: "DonutStatusCode",
			headerName: "Status",
			minWidth: 20,
			maxWidth: 70,
			flex: 1,
			valueGetter: (params) =>
				donutStatusCodes.find(
					(code) => code.Code === (params.data as Donut).DonutStatusCode,
				)?.Name,
			cellRenderer: DonutStatusTag,
			cellRendererParams: (params: ICellRendererParams) => ({
				status: donutStatusCodes.find(
					(code) => code.Code === (params.data as Donut).DonutStatusCode,
				),
			}),
		},
		{
			field: "-",
			cellRenderer: GridButtons,
			cellRendererParams: (params: ICellRendererParams) => ({
				setId: setSelectedRowData,
				id: params.data as Donut,
				edit: false,
				setShowModal: setShowModal,
				showContextMenu: () =>
					showContextMenu(event, params.data, "donutContext"),
			}),
			wrapText: false,
			autoHeight: false,
			wrapHeaderText: false,
			headerName: "",
			flex: 1,
			autoHeaderHeight: true,
		},
	];
	return { columnDefs };
};
